module.exports = __webpack_public_path__ + "img/Waang.png";